
import React, { Component } from 'react';
import AmCharts from "@amcharts/amcharts3-react";
import { inject, observer } from "mobx-react";
import * as mobx from 'mobx'
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
const areas = require('./areas')
const STATES = ["AL","AZ","AR","CA","CO","CT","DE","FL","GA","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"];




export default class States extends Component {
constructor(props) {
    super(props);
    this.state = {
      states: STATES
    }
}


addLabels = (map) => {
       console.log('addLabels')
       console.log(map)
      // set up a longitude exceptions for certain areas
      var longitude = {
        "US-CA": -130,
        "US-FL": 120,
        "US-TX": 1,
        "US-LA": 40
      };
      
      var latitude = {
        "US-AK": -85
      };
      
      setTimeout(function () {
        // iterate through areas and put a label over center of each
        map.dataProvider.images = [];
        for( let x in map.dataProvider.areas ) {
          var area = map.dataProvider.areas[ x ];
          area.groupId = area.id;
          var image = new AmCharts.MapImage();
          image.latitude = latitude[ area.id ] || map.getAreaCenterLatitude( area );
          image.longitude = longitude[ area.id ] || map.getAreaCenterLongitude( area );
          image.label = area.id.split('-').pop();
          image.title = area.title;
          image.labelColor = '#FFFFFF';
          image.linkToObject = area;
          image.groupId = area.id;
          map.dataProvider.images.push( image );
        }
        map.validateData();
        console.log(map.dataProvider);
      }, 100)
}




getRegions = () => {
  const { filters } = this.props
  const { topLevel } = filters
  let regions = []
  console.log(topLevel)
  const regionFilterFound = topLevel.filter((item) => {
    return item.field === 'region'
  })

  console.log(regionFilterFound)


  if(regionFilterFound.length > 0){
    regions = [...regionFilterFound[0].include]
  }

  return regions
}
update = (region) => {

      const { handleUpdate } = this.props
      const selected = this.getRegions()
      const currentIndex = selected.indexOf(region);

      console.log(selected)

    if (currentIndex === -1) {
      selected.push(region);
    } else {
      selected.splice(currentIndex, 1);
    }

    console.log(selected)

    handleUpdate({
      "field": "region",
      "include": selected,
      "recordType": "profile"
    }) 

}

handleToggleStates = (event) => {
    console.log('handleToggleStates')
    console.log(event)
    const { id } = event.mapObject
   // const region = event.mapObject.id.split('-')[1]
   if(id){
    const region = id.split('-')[1]
    console.log('region ' + id)
    const { handleUpdate, regions } = this.props
    const selected = this.getRegions()
    const currentIndex = selected.indexOf(region);
  
      if (currentIndex === -1) {
        selected.push(region);
      } else {
        selected.splice(currentIndex, 1);
      }

      handleUpdate({
        "field": "region",
        "include": selected,
        "recordType": "profile"
      }) 
    }

};
makeStates = () => {
    const { states } = this.state
    const regions = this.getRegions()


    let selected = []

      if(regions){
        selected = [...regions]
      }

    console.log(selected)


    
    return states.map(state => {
    //  console.log(areas[`US-${state}`])
        return {
          id: `US-${state}`,
          showAsSelected: selected.includes(state),
          selectedColor: '#66FCF1',
          color: '#424242',
          value: areas[`US-${state}`]
        }
    })
}

showStateSelections = () => {
  const regions = this.getRegions()
  
  return <Typography style={{textAlign:'center', marginBottom: 20}}> {`Selected: ${regions.join(', ')}`}</Typography>

}


makeRegionOptions = () => {

const mapObjects = this.makeStates()

    return mapObjects.map(mapObject => {
      const { id, showAsSelected } = mapObject
      const label = id.split('-')[1]
            return (
              <FormControlLabel
              key={label}
              control={
                <Checkbox
                  key={label}
                  checked={showAsSelected}
                  onChange={() => this.handleToggleStates({mapObject})}
                  value={id}
                  color="primary"
                />
              }
              label={label}
            />
          )
    })
}
render(){
 //config as same as yours but inside const


 const config = {
    "type": "map",
    "theme": "light",
    zoomOnDoubleClick: false,
    //"colorSteps": 10,
    "dataProvider": {
        "map": "usaLow",
        "areas": this.makeStates()
    },
    "areasSettings": {
        "autoZoom": false,
        selectable: true
    },
    "zoomControl": {
      "zoomControlEnabled": false
    },
    /*"valueLegend": {
        "right": 10,
        "minValue": "little",
        "maxValue": "a lot!"
    },*/
    "imagesSettings": {
      "labelPosition": "middle",
      "labelFontSize": 8
    },
    "listeners": [
      {
        "event": "init",
        "method": (e) => {
          const { chart } = e
          if(chart){
            this.addLabels(chart)
          }
        }
      },
      {
        "event": "clickMapObject",
        "method": this.handleToggleStates
    }]
};


  return (
        <div>
        <Paper 
        style={{border: '2px solid #00FEE6',
        //style={{border: qualifier === 'standard' ? '2px solid #00FEE6' : '2px solid #1F2833',
        width:'100%',
        padding: 20,
        marginBottom: 20,
        textAlign:'left'
        }} 
>
    <Typography style={{marginBottom: 10}}> Select Your States: </Typography>
        {this.makeRegionOptions()}
        </Paper>
        <Card style={{marginBottom: 20, padding:10}}>
        <AmCharts.React style={{ width: "100%", height: "500px" }} options={config} />
        </Card>
        </div>
  )
   }
}


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/States.js